(function() {
    'use strict';

    angular.module('app.widgets', []);
})();
